import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Step } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { cn } from '@/lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function Navigation() {
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col">
      {ctx.state.steps.map((step, index) => (
        <StepItem
          key={index}
          step={step}
          active={ctx.state.currentStepIndex === index}
          last={index === ctx.state.steps.length - 1}
          handleClick={() => {
            ctx.navigateToStep(index);
          }}
        />
      ))}
    </div>
  );
}

// eslint-disable-next-line complexity
function StepItem({
  step,
  active,
  last,
  handleClick,
}: {
  step: Step;
  active: boolean;
  last: boolean;
  handleClick?: () => void;
}) {
  const { ctx } = useAnlageassistentContext();
  const ready = ctx.validateStepReady(step);

  return (
    <div
      className="flex gap-4 items-start justify-start cursor-pointer"
      onClick={handleClick}>
      <div className="flex flex-col items-center">
        <div
          className={cn(
            `rounded-full size-9  flex items-center justify-center text-neutrals-100 bg-neutrals-500`,
            ready && 'bg-primary-green-100 text-primary-green-500',
            active && 'bg-primary-blue-500 text-neutrals-100',
          )}>
          <FontAwesomeIcon icon={step.icon} />
        </div>
        {!last && (
          <div
            className={cn(
              'w-0.5 h-8 bg-neutrals-500',
              ready && 'bg-primary-green-500',
              active && 'bg-primary-blue-500',
            )}></div>
        )}
      </div>
      <div className="h-9 flex flex-col justify-center">
        <span
          className={cn(
            'text-sm text-neutrals-900',
            active ? 'font-bold' : 'font-normal',
          )}>
          {step.title}
        </span>
      </div>
    </div>
  );
}
